import { render, staticRenderFns } from "./DiscountsList.vue?vue&type=template&id=530cc901&scoped=true"
import script from "./DiscountsList.vue?vue&type=script&lang=js"
export * from "./DiscountsList.vue?vue&type=script&lang=js"
import style0 from "./DiscountsList.vue?vue&type=style&index=0&id=530cc901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cc901",
  null
  
)

export default component.exports